import React from 'react'

const About = () => {
  return (
    <>
  {/* Header Start */}
  <div className="container-fluid bg-breadcrumb">
    <ul className="breadcrumb-animation">
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
      <li />
    </ul>
    <div className="container text-center py-5" style={{ maxWidth: 900 }}>
      <h3 className="display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">
        About Us
      </h3>
      <ol
        className="breadcrumb justify-content-center mb-0 wow fadeInDown"
        data-wow-delay="0.3s"
      >
        <li className="breadcrumb-item">
          <a href="/">Home</a>
        </li>
        <li className="breadcrumb-item active text-primary">About</li>
      </ol>
    </div>
  </div>
  {/* Header End */}
  {/* About Start */}
  <div
    className="container-fluid overflow-hidden py-5"
    style={{
      marginTop: "6rem",
      background:
        'linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url("../../assets/img/bg-pattern.png")'
    }}
  >
    <div className="container py-5">
      <div className="row g-5 align-items-center">
        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
          <div className="position-relative overflow-hidden rounded-4 shadow-lg">
            <img
              src="../../assets/img/about-1.png"
              className="img-fluid w-100 transform-hover"
              alt=""
            />
          </div>
        </div>
        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
          <div className="ps-lg-5">
            <div className="border-start border-5 border-primary ps-4 mb-4">
              <h6 className="text-body text-uppercase mb-2">About Us</h6>
              <h1 className="display-6 mb-0">
                Start Your Journey with a Personalized Project Tour
              </h1>
            </div>
            <p className="mb-4 text-muted">
              Company established year 2018.
            </p>
            <p className="mb-4 text-muted">
              Take the first step toward realizing your vision with a guided
              project tour, personalized just for you. Explore cutting-edge
              tools, efficient workflows, and proven techniques that ensure
              quality and reliability at every stage.
            </p>
            <div className="bg-light p-4 rounded-3 mb-4">
              <h5 className="text-primary">Your Project, Our Priority</h5>
              <p className="mb-0">
                With a customized tour, see firsthand how we turn ideas into
                reality. From groundbreaking designs to flawless execution,
                we're here to bring your dreams to life with precision and care.
              </p>
            </div>
            <div className="bg-light p-4 rounded-3 mb-4">
              <h5 className="text-primary">See What's Possible</h5>
              <p className="mb-0">
                Join us for a personalized tour that highlights innovative
                solutions, expert craftsmanship, and unmatched commitment to
                excellence. Let us show you how we can make your project a
                success, every step of the way.
              </p>
            </div>
            <div className="d-flex align-items-center">
              <a
                href="/contact"
                className="btn btn-outline-primary rounded-pill py-3 px-5 ms-3"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* About End */}
  {/* Feature Start */}
  <div className="container-fluid feature overflow-hidden py-5">
    <div className="container py-5">
      <div
        className="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ maxWidth: 900 }}
      >
        <span className="text-primary text-uppercase fw-bold">
          Our Services
        </span>
        <h1 className="display-5 mb-4">Innovative Solutions for Your Vision</h1>
        <p className="lead text-muted mb-0">
          We offer comprehensive services tailored to transform your ideas into
          reality. Our expert team combines creativity with technical excellence
          to deliver outstanding results that exceed expectations.
        </p>
      </div>
      <div className="row g-4 justify-content-center mb-5">
        <div
          className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
          data-wow-delay="0.1s"
        >
          <div className="card h-100 border-0 shadow-sm hover-scale">
            <div className="card-body text-center p-4">
              <div className="feature-img mb-4">
                <img
                  src="./../../assets/img/a1.png"
                  alt="Engineering Works"
                  className="img-fluid rounded-4"
                  style={{ height: 220, objectFit: "cover" }}
                />
              </div>
              <h4 className="mb-3">Engineering Works</h4>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
          data-wow-delay="0.3s"
        >
          <div className="card h-100 border-0 shadow-sm hover-scale">
            <div className="card-body text-center p-4">
              <div className="feature-img mb-4">
                <img
                  src="./../../assets/img/a2.png"
                  alt="Interior Design"
                  className="img-fluid rounded-4"
                  style={{ height: 220, objectFit: "cover" }}
                />
              </div>
              <h4 className="mb-3">Interior Design</h4>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
          data-wow-delay="0.5s"
        >
          <div className="card h-100 border-0 shadow-sm hover-scale">
            <div className="card-body text-center p-4">
              <div className="feature-img mb-4">
                <img
                  src="./../../assets/img/a3.png"
                  alt="Architecture Studio"
                  className="img-fluid rounded-4"
                  style={{ height: 220, objectFit: "cover" }}
                />
              </div>
              <h4 className="mb-3">Architecture Studio</h4>
            </div>
          </div>
        </div>
        <div
          className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp"
          data-wow-delay="0.7s"
        >
          <div className="card h-100 border-0 shadow-sm hover-scale">
            <div className="card-body text-center p-4">
              <div className="feature-img mb-4">
                <img
                  src="./../../assets/img/a4.png"
                  alt="Visualize Your Idea"
                  className="img-fluid rounded-4"
                  style={{ height: 220, objectFit: "cover" }}
                />
              </div>
              <h4 className="mb-3">Visualize Your Idea</h4>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
        <a
          href="/service"
          className="btn btn-primary btn-lg rounded-pill px-5 py-3 shadow-sm"
        >
          Explore All Services <i className="fas fa-arrow-right ms-2" />
        </a>
      </div>
    </div>
  </div>
  {/* Feature End */}
</>

  )
}

export default About